import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function AdvertisingMediaSpend({ advertisingAndMediaSpend }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     atl_spend: "b",
  //     btl_spend: "c",
  //     digital_marketing_spend: "d",
  //     sponsorships: "d",
  //     atl_spend_positive_insight: "b",
  //     atl_spend_negative_insight: "b",
  //     atl_spend_recent_development: "b",
  //     btl_spend_positive_insight: "c",
  //     btl_spend_negative_insight: "c",
  //     btl_spend_recent_development: "c",
  //     digital_marketing_spend_positive_insight: "d",
  //     digital_marketing_spend_negative_insight: "d",
  //     digital_marketing_spend_recent_development: "d",
  //     sponsorships_positive_insight: "d",
  //     sponsorships_negative_insight: "d",
  //     sponsorships_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     atl_spend: "b",
  //     btl_spend: "c",
  //     digital_marketing_spend: "d",
  //     sponsorships: "d",
  //     atl_spend_positive_insight: "b",
  //     atl_spend_negative_insight: "b",
  //     atl_spend_recent_development: "b",
  //     btl_spend_positive_insight: "c",
  //     btl_spend_negative_insight: "c",
  //     btl_spend_recent_development: "c",
  //     digital_marketing_spend_positive_insight: "d",
  //     digital_marketing_spend_negative_insight: "d",
  //     digital_marketing_spend_recent_development: "d",
  //     sponsorships_positive_insight: "d",
  //     sponsorships_negative_insight: "d",
  //     sponsorships_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     atl_spend: "b",
  //     btl_spend: "c",
  //     digital_marketing_spend: "d",
  //     sponsorships: "d",
  //     atl_spend_positive_insight: "b",
  //     atl_spend_negative_insight: "b",
  //     atl_spend_recent_development: "b",
  //     btl_spend_positive_insight: "c",
  //     btl_spend_negative_insight: "c",
  //     btl_spend_recent_development: "c",
  //     digital_marketing_spend_positive_insight: "d",
  //     digital_marketing_spend_negative_insight: "d",
  //     digital_marketing_spend_recent_development: "d",
  //     sponsorships_positive_insight: "d",
  //     sponsorships_negative_insight: "d",
  //     sponsorships_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(advertisingAndMediaSpend);
    setTabData(tableData);
  }, [advertisingAndMediaSpend]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "atl_spend", label: "ATL Spend" },
    { key: "btl_spend", label: "BTL Spend" },
    { key: "digital_marketing_spend", label: "Digital Marketing Spend" },
    { key: "sponsorships", label: "Sponsorships" },
  ];

  return (
    <InsightTable
      title="Advertising & Media Spend"
      subtitle="Comparative overview of above-the-line (ATL), below-the-line (BTL), digital marketing, and sponsorship strategies across top healthcare suppliers."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default AdvertisingMediaSpend;
